import React from "react";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  Container,
  Row,
  Col,
} from "reactstrap";

// core components

function Tabs() {
  const [iconPills, setIconPills] = React.useState("1");
  /* const [pills, setPills] = React.useState("1"); */
  return (
    <>
      <div className="section section-tabs" style={{backgroundColor: "#2C2C2C"}}  /*         style={{
            backgroundImage:
              "url(" + require("assets/img/star.jpg").default + ")",
          }} */ id="tabs-section">
        <Container>
          <Row>
            <Col className="ml-auto mr-auto" md="10" xl="6">
              <Card>
                <CardHeader>
                  <Nav className="justify-content-center" role="tablist" tabs>
                    <NavItem>
                      <NavLink
                        className={iconPills === "1" ? "active" : ""}
                        href="#pablo"
                        onClick={(e) => {
                          e.preventDefault();
                          setIconPills("1");
                        }}
                      >
                        <i className="now-ui-icons objects_diamond"></i>
                        Le Gala de l'INSA HDF
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={iconPills === "2" ? "active" : ""}
                        href="#pablo"
                        onClick={(e) => {
                          e.preventDefault();
                          setIconPills("2");
                        }}
                      >
                        <i className="now-ui-icons education_hat"></i>
                        L'INSA Hauts-de-France
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={iconPills === "3" ? "active" : ""}
                        href="#pablo"
                        onClick={(e) => {
                          e.preventDefault();
                          setIconPills("3");
                        }}
                      >
                        <i className="now-ui-icons shopping_shop"></i>
                        L'association
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={iconPills === "4" ? "active" : ""}
                        href="#pablo"
                        onClick={(e) => {
                          e.preventDefault();
                          setIconPills("4");
                        }}
                      >
                        <i className="now-ui-icons ui-2_settings-90"></i>
                        L'équipe
                      </NavLink>
                    </NavItem>
                  </Nav>
                </CardHeader>
                <CardBody>
                  <TabContent
                    className="text-justify"
                    activeTab={"iconPills" + iconPills}
                  >
                    <TabPane tabId="iconPills1">
                      <p>
                      Le gala de l'INSA HDF se déroulera le samedi 05 Mars 2022, à la Cité des Congrès de
Valenciennes. Dans cette salle exceptionnelle, se réunissent plusieurs centaines d’élèves,
de jeunes diplômés, de professeurs et d'industriels. Cette soirée s’articule autour d’un
dîner-spectacle. La salle est ensuite transformée en piste de danse animée par un DJ.. Au
cours de cette soirée, teintée de multiples surprises, les élèves, les diplômés et les invités
seront mis à l’honneur.
                      </p>
                    </TabPane>
                    <TabPane tabId="iconPills2">
                      <p>
                      <Row>
                        <Col className="ml-auto mr-auto" md="7">
                          {/* <p className="category">Groupe Renault</p> */}
                          <img
                            alt="..."
                            className="rounded"
                            src={require("assets/img/insa_bat.jpg").default}
                          ></img>
                        </Col>
                      </Row>
                      <br></br>
                      L'INSA Hauts-de-France est membre du groupe INSA, il s’agit du septième institut créé le
1er Janvier 2020. Reconnue par la Commission des Titres d'Ingénieurs depuis 1979, elle
propose 11 formations différentes, en formation initiale ou par apprentissage. Les ingénieurs
sortant de l'école INSA Hauts-de-France travaillent principalement dans les domaines de
l'automobile, de l'aéronautique, du ferroviaire ainsi que de l'énergie.
                      </p>
                    </TabPane>
                    <TabPane tabId="iconPills3">
                      <p>
                      <Row>
                        <Col className="ml-auto mr-auto" md="3">
                          {/* <p className="category">Groupe Renault</p> */}
                          <img
                            alt="..."
                            className="rounded"
                            src={require("assets/img/logo-nuit.png").default}
                          ></img>
                        </Col>
                      </Row>
                      <br></br>
                      Nuit INSA est une association étudiante à but non lucratif. Elle a pour vocation de mener à
bien l’organisation du gala de l’école afin de promouvoir l’image de l’INSA lors de cette
soirée exceptionnelle. Pour que cela soit possible, elle organise des évènements au sein de
l'institut tout au long de l’année.
                      </p>
                    </TabPane>
                    <TabPane tabId="iconPills4">
                      <p className="text-center">
                      <strong>Président</strong> : <br></br>Lucas Julhe<br></br> <strong>Trésorière</strong> :<br></br> Estelle Mouilleron<br></br><strong>Vice-présidente</strong> :<br></br> Laurine
Benezech<br></br> {/* <strong>Secrétaire</strong> :<br></br> Arnaud Techer<br></br> */} <strong>Responsable Communication</strong> :<br></br> Camille Lambert

                      </p>                
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default Tabs;
